<template>
	<div class="login" :style="tmpTheme" v-if="loginShow">
		<!-- 登录弹窗 -->
		<el-dialog title="" :visible.sync="loginShow" width="1008px" class="login-dialog" @close="closeLogin"
			:close-on-click-modal="false">
			<div class="dialog-main">
				<div class="log_header">
					<img :src="base.imgWebUrl+imgInfo.pc_Img"></img>
				</div>
				<div class="conmain">
					<div class="conmain-left">
						<h3>手机扫码安全登录</h3>
						<p>支持 <img src="../../assets/img/wx-icon.png" alt=""> <span>微信登录</span></p>
						<div id="login_container" v-loading="codeLoading">

						</div>
						<div class="qrcode-refresh" @click="refreshWxLogin">
							<i class="el-icon-refresh"></i>
							<span>刷新二维码</span>
						</div>
					</div>
					<div class="conmain-right">
						<div class="login_title">
							<ul>
								<li style="margin-right: 10px;" :style="{'color': selected==1?varbgColor:''}"
									@click="loginChange(1)">密码登录</li>
								<li style="margin-left: 10px;" :style="{'color': selected==2?varbgColor:''}"
									@click="loginChange(2)">短信登录</li>
							</ul>
							<div style="clear:both;"></div>
						</div>
						<div v-show="selected==1">
							<div class="login_input">
								<img src="../../assets/img/phone-icon.png" alt="">
								<input type="text" placeholder="请输入用户名或手机号" v-model="username" @blur="userBlur">
							</div>
							<div class="login_input">
								<img src="../../assets/img/pass-icon.png" alt="">
								<input type="password" placeholder="请输入登录密码" v-model="password">
							</div>

							<div id="msgtips" v-show="isShow">
								<dd><span class="text">密码错误，你还可以尝试<span
											class="num">{{ loginNum }}</span>次。</span>点击此处<span class="btn_f"
										@click="forgetPwd()">找回密码</span></dd>
							</div>

							<!-- <div class="login_label clearfix" id="chkRemember">
								<label><input type="checkbox" v-model="chkRemember"> 自动登录</label>
								<a @click="forgetPwd()">忘记密码?</a>
							</div> -->

							<input id="btnSubmit" name="btnSubmit" type="submit" class="login_btn"
								:style="{'background': varbgColor,'color': varfontColor}" value="登  录"
								@click="logs()" />

						</div>
						<div v-show="selected==2">
							<div class="login_input">
								<input type="text" placeholder="请输入手机号" v-model="imgForm.mobile">
							</div>

							<div class="login_input">
								<input class="input small" placeholder="请输入短信验证码" type="text"
									v-model="imgForm.mobileCode" style="ime-mode:disabled;text-transform:uppercase;">
								<input type="button" class="btn btn_code sendCode" :class="{disabled:disabled}"
									:value="timetext" :disabled="disabled"
									:style="{'background': varbgColor,'color': varfontColor}" @click="openImgCode(2)">
							</div>
							<!-- <div class="login_label clearfix" id="chkRemember">
								<label><input type="checkbox" v-model="chkRemember">自动登录</label>
								<a @click="forgetPwd()">忘记密码?</a>
							</div> -->

							<input id="btnSubmit" name="btnSubmit" type="submit" class="login_btn"
								:style="{'background': varbgColor,'color': varfontColor}" value="登  录"
								@click="mobileLogin(1)" />
						</div>
						<div class="login-span">
							<!-- <span><img src="../../assets/img/wx-icon.png" alt=""></img>微信登录</span> -->
							<span @click="forgetPwd()">忘记密码</span>
							<span :style="{'color': varbgColor}" @click="$dialog.showRegisterDialog()">立即注册</span>
							<!-- <router-link to="/register" :style="{'color': varbgColor}">立即注册</router-link> -->
						</div>
						<!-- <div class="login_bot">
							没有账号，<router-link to="/register" :style="{'color': varbgColor}">免费注册</router-link>
						</div> -->
					</div>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="找回密码" :visible.sync="dialogFormVisible" :close-on-click-modal="false" class="dialogL"
			@close="dialogCloose">
			<div class="protocolContent">
				<div class="step_wrap">
					<div class="item step1" :class="{active:stepNum>=1}"><span>1.输入手机号</span></div>
					<div class="item step2" :class="{active:stepNum>=2}"><span>2.重置密码</span></div>
					<div class="item step3" :class="{active:stepNum>=3}"><span>3.完成</span></div>
				</div>
				<div class="form_box">
					<div class="part" v-show="stepNum==1">
						<dl>
							<dt>手机号：</dt>
							<dd><input type="text" class="input txt" v-model="form.mobile"></dd>
						</dl>
						<dl>
							<dt>验证码：</dt>
							<dd>
								<input class="input small" type="text" v-model="form.imgCode"
									style="ime-mode:disabled;text-transform:uppercase;">
								<el-image :src="form.imgCodeUrl" v-loading="imgCodeLoading" fit="fit"
									@click="getVierificationCode()"></el-image>
							</dd>
						</dl>
						<dl>
							<dt>手机验证码：</dt>
							<dd>
								<input class="input small" type="text" v-model="form.mobileCode"
									style="ime-mode:disabled;text-transform:uppercase;">
								<input type="button" class="btn btn_code" :class="{disabled:wj_disabled}"
									:disabled="wj_disabled" :value="wj_timetext"
									:style="{'background': varbgColor,'color': varfontColor}"
									@click="sendMobileCode('wj')">
							</dd>
						</dl>
					</div>
					<div class="part" v-show="stepNum==2">
						<dl>
							<dt>密码：</dt>
							<dd>
								<div class="input_item">
									<input class="input txt" :type="type" v-model="form.pwd" @blur="checkPW"
										@input="inputP">
									<i class="iconfont off" v-show="passWd==1" @click="showPW(1)">&#xe8bf;</i>
									<i class="iconfont on" v-show="passWd==2" @click="showPW(2)">&#xe8c7;</i>
								</div>
								<div class="pwStrong">
									<div class="input_span">
										<span id="one"></span>
										<span id="two"></span>
										<span id="three"></span>
									</div>
									<div class="pw_font">
										<span v-show="msgText==1">弱</span>
										<span v-show="msgText==2">中</span>
										<span v-show="msgText==4">强</span>
									</div>
								</div>
							</dd>
						</dl>
						<dl>
							<dt>确认密码：</dt>
							<dd>
								<div class="input_item">
									<input class="input txt" :type="type2" recheck="txtPassword" v-model="form.surePwd"
										@blur="checkSPW">
									<i class="iconfont off" v-show="passWd2==1" @click="showPW2(1)">&#xe8bf;</i>
									<i class="iconfont on" v-show="passWd2==2" @click="showPW2(2)">&#xe8c7;</i>
								</div>
							</dd>
						</dl>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="sumbtn" size="small" @click="checkCode(1)"
					:style="{'background': varbgColor,'color': varfontColor}" v-show="stepNum==1">下一步</el-button>
				<el-button class="sumbtn" size="small" @click="saveForgetPwd(2)"
					:style="{'background': varbgColor,'color': varfontColor}" v-show="stepNum==2">确认提交</el-button>
			</span>
		</el-dialog>

		<el-dialog title="图文验证码" :visible.sync="imgCodeDialogFormVisible">
			<div class="protocolContent">
				<div class="form_box">
					<dl>
						<dt>验证码：</dt>
						<dd>
							<input class="input small" type="text" v-model="imgForm.imgCode"
								style="ime-mode:disabled;text-transform:uppercase;">
							<el-image :src="imgForm.imgCodeUrl" v-loading="imgCodeLoading" fit="fit"
								@click="getVierificationCodeToLogin()"></el-image>
						</dd>
					</dl>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="sumbtn" size="small" @click="sendMobileCode('wj')">确认发送</el-button>
			</span>
		</el-dialog>
		<!-- ip不同验证 -->
		<el-dialog title="" :visible.sync="ipShow" width="600px">
			<div class="protocolContent ipmatch">

				<!-- <img class="logo" :src="webLogo"/> -->
				<div class="tips"><i class="iconfont">&#xe8c6;</i><span>您本次登录不在上次IP地址，需要通过短信验证登录。</span></div>
				<div class="form_box">
					<div>
						<div class="login_input">
							<input type="text" placeholder="请输入手机号" v-model="imgFormIp.mobile" disabled>
						</div>
						<div class="login_input">
							<input class="input small" type="text" v-model="imgFormIp.imgCode"
								style="ime-mode:disabled;text-transform:uppercase;">
							<el-image :src="imgFormIp.imgCodeUrl" v-loading="imgCodeLoading" fit="fit"
								@click="getVierificationCodeIp()"></el-image>
						</div>
						<div class="login_input">
							<input class="input small" placeholder="请输入短信验证码" type="text" v-model="imgFormIp.mobileCode"
								style="ime-mode:disabled;text-transform:uppercase;">
							<input type="button" class="btn btn_code sendCode" :class="{disabled:y_disabled}"
								:disabled="y_disabled" :value="y_timetext" @click="openImgCode(3)">
						</div>

					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="sumbtn ipmatchbtn" size="small" @click="mobileLogin(2)">登  录</el-button>
			</span>
		</el-dialog>
		<!-- ip不同验证 -->

		<SlideVerify ref="slideblock" @success="sliderVerifySuccessHandle" :show="isShowSlide"></SlideVerify>
		<!-- <RegDialog :showRegister="showRegister" @closeRegisterVue="closeRegiste" /> -->
	</div>
</template>
<script>
	let timeOut = null;
	import layer from "layui-layer";
	import SlideVerify from "../SlideVerify.vue"; //引入图片滑动验证功能
	import '../../assets/js/wxLogin.js'
	import { syncBuyerFlagsFromStorage } from '../../assets/js/buyerSync.js';
	export default {
		name: 'LoginDialog',
		props: {
			// showLogin: {
			// 	type: Boolean,
			// 	default: false
			// }
		},
		watch: {
			showLogin: {
				handler(newValue, oldValue) {
					// console.log('myObject changed:', newValue, oldValue);
					let _this = this
					_this.loginShow = newValue;
					setTimeout(() => {
						this.initWxLogin()
					}, 500)
					// console.log(_this.loginShow,'pppp');
				},
				deep: true,
			},
		},

		components: {
			SlideVerify
		},
		data() {
			return {
				showLogin: false,
				loginShow: false,
				showRegister: false,
				isShowSlide: false, //图片滑动验证功能

				isShow: false,
				loginNum: '',
				totalNum: 5,
				stepNum: 1,

				username: '',
				password: '',
				admin: '',
				show: true,
				Verification: '',
				user: '',
				form: {
					mobile: '',
					imgCode: '',
					mobileCode: '',
					imgCodeUrl: '',
					imgUid: '',
					pwd: '',
					surePwd: ''
				},
				type: 'password',
				passWd: 1,
				type2: 'password',
				passWd2: 1,
				imgForm: {
					mobile: '',
					imgCode: '',
					mobileCode: '',
					imgCodeUrl: '',
					imgUid: ''
				},
				dialogFormVisible: false,
				imgCodeLoading: false,
				imgCodeDialogFormVisible: false,
				selected: 1,
				base: '',
				webLogo: '',
				chkRemember: false,

				imgInfo: {
					pc_Img: '',
					phone_Img: '',
					href: ''
				},
				varbgColor: '',
				varfontColor: '',

				imgFormIp: {
					mobile: '',
					imgCode: '',
					mobileCode: '',
					imgCodeUrl: '',
					imgUid: ''
				},
				ipShow: false,
				userIp: '',
				isLoginSms: false, //是否开启异地登陆短信验证
				isLoginValidity: 0, //登陆账号有效期设置 0一周之内有效 1永久有效

				//倒计时
				count: 0,
				timer: null,
				disabled: false,
				timetext: '获取验证码',
				//忘记密码倒计时
				wj_count: 0,
				wj_timer: null,
				wj_disabled: false,
				wj_timetext: '获取验证码',
				//异地登录倒计时
				y_count: 0,
				y_timer: null,
				y_disabled: false,
				y_timetext: '获取验证码',

				msgText: 0,
				codeLoading: true
			}
		},
		computed: {
			tmpTheme() {
				return {
					'--bgColor': this.$store.state.sysConfig.colorConfig.bgColor,
					'--fontColor': this.$store.state.sysConfig.colorConfig.fontColor
				};
			}
		},
		beforeDestroy() {
			clearInterval(this.timer)
			clearInterval(this.w_timer)
			clearInterval(this.y_timer)
		},
		created() {
			const _this = this;
			_this.loadconfig(true, function(data) {
				_this.base = _this.$store.state.sysConfig.baseConfig
				_this.webLogo = _this.base.imgWebUrl + _this.base.webLogo
				_this.varbgColor = _this.$store.state.theme.bgColor
				_this.varfontColor = _this.$store.state.theme.fontColor

				_this.isLoginSms = _this.$store.state.sysConfig.loginConfig.isLoginSms
				_this.isLoginValidity = _this.$store.state.sysConfig.loginConfig.isLoginValidity
			})
			// this.getVierificationCodeToLogin(); 
			if (this.isLoginSms) {
				//内网ip
				this.getIPs();
			}

			this.$api.GetAdvertisement({
				type: 5,
			}).then(res => {
				this.imgInfo = {
					pc_Img: res.data.pc_Img,
					phone_Img: res.data.phone_Img,
					href: res.data.href
				}
			})
			window.addEventListener('keydown', this.handkeyCode, true) //开启监听键盘按下事件
		},
		mounted() {
			this.$toastBus.$on('showLoginDialog', this.showDialog)
		},
		beforeUpdate() {
			document.title = this.base.webTitle
			let key = document.querySelector("meta[name*='keywords']" || document.createElement('meta'))
			let descri = document.querySelector("meta[name*='description']" || document.createElement('meta'))
			key.content = this.base.webKeyword
			descri.content = this.base.webDescription
			key.name = 'keywords'
			descri.name = 'description'
		},
		beforeDestroy() {
			window.removeEventListener('keydown', this.handkeyCode, true) //关闭监听键盘按下事件
		},
		methods: {
			dialogCloose() {
				this.form = {
					mobile: '',
					imgCode: '',
					mobileCode: '',
					imgCodeUrl: '',
					imgUid: '',
					pwd: '',
					surePwd: ''
				}
				this.stepNum = 1;
			},
			showDialog() {
				//401强制登出路径（removeItem buyerInfo 后弹框，不导航不刷新）在此立即复位遮价等买家开关
				syncBuyerFlagsFromStorage();
				if ('openWeChatLogin' in this.$store.state.sysConfig.funcConfig && this.$store.state.sysConfig.funcConfig
					.openWeChatLogin) {
					this.showLogin = !this.showLogin;
				} else {
					this.$router.push({
						path: '/Login'
					})
				}
			},
			//刷新微信登录二维码
			refreshWxLogin() {
				if (this.codeLoading) return; //正在获取中，避免重复点击
				this.initWxLogin();
			},
			async initWxLogin() {
				this.codeLoading = true;
				let res = await this.$api.WeChatLoginConfig();
				console.log('initWxLogin');
				console.log(res);
				if (res.data.status) {
					var obj = new WxLogin({
						self_redirect: false,
						id: "login_container",
						appid: res.data.data.appId,
						scope: "snsapi_login",
						redirect_uri: res.data.data.redirectUri,
						href: "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDE3MnB4fQouaW1wb3dlckJveCAudGl0bGUge2Rpc3BsYXk6IG5vbmV9Ci5pbXBvd2VyQm94IC5pbmZvIHt3aWR0aDogMTcycHh9Ci5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZX0KLmltcG93ZXJCb3ggLnN0YXR1cyB7dGV4dC1hbGlnbjogY2VudGVyfSAKLmpzX3d4X2RlZmF1bHRfdGlwe2Rpc3BsYXk6IG5vbmV9Ci5qc193eF9hZnRlcl9zY2Fue2Rpc3BsYXk6bm9uZSAhaW1wb3J0YW50fQouanNfd3hfYWZ0ZXJfY2FuY2Vse2Rpc3BsYXk6bm9uZSAhaW1wb3J0YW50fQ==",
						state: '',
						onReady: (isReady) => {
							console.log(isReady);
							this.codeLoading = false;
						}
					});
				} else {

				}

			},
			closeLogin() {
				this.showLogin = false
			},
			closeRegiste(val) {
				this.showRegister = val
			},
			userBlur() {
				if (!this.username) {
					return
				}
				if (timeOut != null) {
					clearTimeout(timeOut)
				}
				timeOut = setTimeout(() => {
					this.$api.getBuyerInfo({
						UserName: this.username
					}).then(res => {
						console.log(res);
						if (res.data.status) {
							if (res.data.data['isFistLogin'] == 1) {
								this.forgetPwd()
							}
						} else {

						}
					})
				}, 200)
			},
			handkeyCode(e) {
				//弹窗未打开时不响应回车：本组件挂在所有页面（含 /login），
				//否则 /login 页按回车会同时触发本弹窗的空表单校验，误报"用户名不能为空"
				if (!this.loginShow) return;
				if (e.keyCode === 13 && this.$route.path == '/login') {
					if (this.selected == 1) {
						this.logs()
					} else if (this.selected == 2) {
						this.mobileLogin(1)
					}
				}
			},
			//异地登录
			getIPs() {
				let _this = this;
				var RTCPeerConnection = window.RTCPeerConnection || window.webkitRTCPeerConnection || window
					.mozRTCPeerConnection;
				if (RTCPeerConnection)(
					function() {
						var rtc = new RTCPeerConnection({
							iceServers: []
						});
						if (1 || window.mozRTCPeerConnection) {
							rtc.createDataChannel('', {
								reliable: false
							});
						};

						rtc.onicecandidate = function(evt) {
							if (evt.candidate) grepSDP("a=" + evt.candidate.candidate);
						};
						rtc.createOffer(function(offerDesc) {
							grepSDP(offerDesc.sdp);
							rtc.setLocalDescription(offerDesc);
						}, function(e) {
							console.warn("offer failed", e);
						});


						var addrs = Object.create(null);
						addrs["0.0.0.0"] = false;

						function updateDisplay(newAddr) {
							if (newAddr in addrs) return;
							else addrs[newAddr] = true;
							var displayAddrs = Object.keys(addrs).filter(function(k) {
								return addrs[k];
							});
							for (var i = 0; i < displayAddrs.length; i++) {
								if (displayAddrs[i].length > 16) {
									displayAddrs.splice(i, 1);
									i--;
								}
							}
							// console.log('内网ip',displayAddrs[0]);      //打印出内网ip
							//_this.$cookie.set('ip', displayAddrs[0])
							_this.userIp = displayAddrs[0]; //获取内网ip
							console.log('内网ip', displayAddrs[0]);
						}

						function grepSDP(sdp) {
							var hosts = [];
							sdp.split('\r\n').forEach(function(line, index, arr) {
								if (~line.indexOf("a=candidate")) {
									var parts = line.split(' '),
										addr = parts[4],
										type = parts[7];
									if (type === 'host') updateDisplay(addr);
								} else if (~line.indexOf("c=")) {
									var parts = line.split(' '),
										addr = parts[2];
									updateDisplay(addr);
								}
							});
						}
					}
				)();
				else {
					console.log("请使用主流浏览器：chrome,firefox,opera,safari");
				}
			},
			logs() {
				const _this = this;
				if (!this.username) {
					this.$notify({
						title: '提示',
						message: '用户名不能为空',
						type: 'warning',
						duration: 2000,
						offset: 300,
						showClose: true
					})
					return false
				}
				this.userBlur()
				if (!this.password) {
					this.$notify({
						title: '提示',
						message: '请输入密码',
						type: 'warning',
						duration: 2000,
						offset: 300,
						showClose: true
					})
					return false
				}
				this.$api.login({
					source: 0,
					loginIP: this.userIp,
					password: this.password,
					userName: this.username,
					IsForget: this.chkRemember ? 1 : 0,
				}).then(res => {
					if (!res.data.status) {
						if (res.data.code == '322') {
							if (this.isLoginSms) {
								this.imgFormIp.mobile = res.data.data;
								this.getVierificationCodeIp();
								this.ipShow = true;
							}

						} else if (res.data.code == '308') {
							this.isShow = true;
							this.loginNum = this.totalNum - res.data.data;
						}
						this.$message.error(res.data.message);
					}
					if (res.data.status) {
						this.isShow = false;
						this.admin = res.data
						localStorage.setItem('token', this.admin.data.token)
						localStorage.setItem('username', this.username)
						// localStorage.setItem('password',this.password)
						// 保存登录人信息
						localStorage.setItem('buyerInfo', JSON.stringify(this.admin.data))
						//保存发票类型 0不开票，1增值税发票，2普通发票
						localStorage.setItem('invoicingType', this.admin.data.invoicingType || 0)
						if (this.isLoginValidity == 0) {

							localStorage.setItem('IsForget', 0)
							//存储本地时间戳
							let nowtime = new Date().getTime();
							localStorage.setItem('nowtime', nowtime);

						} else if (this.isLoginValidity == 1) {
							if (!this.chkRemember) {
								localStorage.setItem('IsForget', 0)
								//存储本地时间戳
								let nowtime = new Date().getTime();
								localStorage.setItem('nowtime', nowtime);
							} else {
								localStorage.setItem('IsForget', 1)
								//存储本地时间戳
								let nowtime = '';
								localStorage.setItem('nowtime', nowtime);
							}
						}



						if (this.$store.state.browser.b == 'trident') {
							this.$cookie.set("token", this.admin.data.token);
						}

						layer.msg('登录成功');
						this.closeLogin()
						// this.$message.success('登录成功');
						setTimeout(() => {
							if (_this.$route.query.redirect) {
								location.replace(decodeURIComponent(_this.$route.query.redirect));
							} else {

								window.location.reload();
								// _this.$router.replace({
								// 	path: '/'
								// });
							}
						}, 1000)
					}

				})
			},
			mobileLogin(type) {
				const _this = this;
				// if(!this.imgForm.mobile){
				//     this.$notify({title: '提示',message:'请输入手机号',type: 'warning',duration:2000,offset: 300,showClose: true})
				//     return false
				// }
				// if(!this.imgForm.imgCode){
				//     this.$notify({title: '提示',message:'请输入图形验证码',type: 'warning',duration:2000,offset: 300,showClose: true})
				//     return false
				// }
				// if(!this.imgForm.mobileCode){
				//     this.$notify({title: '提示',message:'请输入短信验证码',type: 'warning',duration:2000,offset: 300,showClose: true})
				//     return false
				// }
				var params = {
					source: 0,
					loginIP: '',
					Mobile: '',
					MobileCode: '',
					IsForget: '',
				}
				if (type == 1) {
					params = {
						source: 0,
						loginIP: this.userIp,
						Mobile: this.imgForm.mobile,
						MobileCode: this.imgForm.mobileCode,
						IsForget: this.chkRemember ? 1 : 0,
					}
				} else if (type == 2) {
					params = {
						source: 0,
						loginIP: this.userIp,
						Mobile: this.imgFormIp.mobile,
						MobileCode: this.imgFormIp.mobileCode,
						IsForget: this.chkRemember ? 1 : 0,
					}
				}
				this.$api.mobileLogin(params).then(res => {
					if (!res.data.status) {
						if (res.data.code == '322') {
							if (this.isLoginSms) {
								this.imgFormIp.mobile = res.data.data;
								this.getVierificationCodeIp();
								this.ipShow = true;
							}
						} else {
							this.$message.error(res.data.message);
						}
					}
					if (res.data.status) {
						this.admin = res.data
						localStorage.setItem('token', this.admin.data.token)
						localStorage.setItem('username', this.imgForm.mobile)
						// localStorage.setItem('password',this.password)
						// 保存登录人信息
						localStorage.setItem('buyerInfo', JSON.stringify(this.admin.data))
						//保存发票类型 0不开票，1增值税发票，2普通发票
						localStorage.setItem('invoicingType', this.admin.data.invoicingType || 0)
						if (!this.chkRemember) {
							localStorage.setItem('IsForget', 0)
							//存储本地时间戳
							let nowtime = new Date().getTime();
							localStorage.setItem('nowtime', nowtime);
						} else {
							localStorage.setItem('IsForget', 1)
							//存储本地时间戳
							let nowtime = '';
							localStorage.setItem('nowtime', nowtime);
						}


						layer.msg('登录成功');
						this.closeLogin()
						// this.$message.success("登录成功");
						setTimeout(() => {
							if (_this.$route.query.redirect) {
								location.replace(decodeURIComponent(_this.$route.query.redirect));
							} else {
								window.location.reload();
								// _this.$router.replace({
								// 	path: '/'
								// });
							}
						}, 1000)
					}

				})
			},
			submit() {
				if (this.user == '') {
					layer.msg('对不起，用户名不可为空！')
				} else if (this.user == 'zzw') {
					layer.msg('对不起，您输入的用户名不存在！')
				} else {
					layer.msg('验证成功')
					setTimeout(() => {
						layer.closeAll()
						this.$router.push('/modify');
					}, 1500)
				}
			},
			getVierificationCode() {
				this.imgCodeLoading = true;
				this.$api.getVierificationCode({}).then(res => {
					this.form.imgCodeUrl = "data:image/png;base64," + res.data.data.img;
					this.form.imgUid = res.data.data.uuid;
					this.imgCodeLoading = false;
				});
			},
			forgetPwd() {
				this.getVierificationCode();
				this.dialogFormVisible = true;
			},
			checkCode(type) {
				let reg = /^1[0-9]{10}$/
				if (type == 1) {
					if (this.form.mobile == undefined || this.form.mobile == '') {
						this.$message.error('请输入手机号')
						return;
					}
					if (!reg.test(this.form.mobile)) {
						this.$message.error('请输入正确手机号!');
						return;
					}
					if (this.form.imgCode == undefined || this.form.imgCode == '') {
						this.$message.error('请输入图文验证码')
						return;
					}
					if (this.form.mobileCode == undefined || this.form.mobileCode == '') {
						this.$message.error('请输入短信验证码')
						return;
					}
				}

				this.$api.ForgetPwdValidCode({
					Mobile: this.form.mobile,
					UUID: this.form.imgUid,
					VerificationCode: this.form.imgCode,
					MobileCode: this.form.mobileCode,
					Pwd: ''
				}).then(res => {
					if (res.data.status) {
						this.stepNum = 2;
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			saveForgetPwd(type) {
				if (type == 2) {
					if (this.form.pwd == undefined || this.form.pwd == '') {
						this.$message.error('请输入密码')
						return;
					} else {
						if (this.form.pwd.length < 8) {
							this.$message.error('请至少输入8位密码，包括数字和字母')
							return
						} else {
							if (!this.form.pwd.match(/^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/)) {
								this.$message.error('请至少输入8位密码，包括数字和字母')
								return
							}
						}
					}
					if (this.form.surePwd == undefined || this.form.surePwd == '') {
						this.$message.error('请输入确认密码')
						return;
					}
					if (this.form.surePwd != this.form.pwd) {
						this.$message.error('两次密码不一致')
						return;
					}
				}

				this.$api.forgetPwd({
					Mobile: this.form.mobile,
					UUID: this.form.imgUid,
					VerificationCode: this.form.imgCode,
					MobileCode: this.form.mobileCode,
					Pwd: this.form.pwd
				}).then(res => {
					if (res.data.status) {
						this.$message.success("修改成功，请使用新密码登录");
						this.dialogFormVisible = false;
						this.isShow = false;
						this.form = {
							mobile: '',
							imgCode: '',
							mobileCode: '',
							imgCodeUrl: '',
							imgUid: '',
							pwd: '',
							surePwd: ''
						}
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			loginChange(selected) {
				this.selected = selected;
			},
			openImgCode(type) {
				const _this = this;
				if (type == 2) {
					if (!this.imgForm.mobile) {
						this.$message.error('请输入手机号')
						return;
					}
					if (this.imgForm.imgCode == undefined || this.imgForm.imgCode == '') {
						this.isShowSlide = true
						return;
					} else {
						this.sendMobileCode(2)
					}

				} else if (type == 3) {
					if (this.imgFormIp.imgCode == undefined || this.imgFormIp.imgCode == '') {
						this.$message.error('请输入图文验证码')
						return;
					}
					this.sendMobileCode(3)
				}
			},
			sliderVerifySuccessHandle(val) {
				if (val) {
					this.imgForm.imgCode = 'test'
					this.isShowSlide = false;
					this.sendMobileCode(2);
				} else {
					this.imgForm.imgCode = ''
					this.isShowSlide = false;
				}
				console.log(this.imgForm.imgCode)
			},
			sendMobileCode(type) {
				var params = {
					IsLogin: '',
					Mobile: '',
					UUID: '',
					VerificationCode: ''
				}
				if (type == 'wj') {
					if (this.form.imgCode == undefined || this.form.imgCode == '') {
						this.$message.error('请输入图文验证码')
						return;
					}
					params = {
						IsLogin: true,
						Mobile: this.form.mobile,
						UUID: this.form.imgUid,
						VerificationCode: this.form.imgCode
					}
				} else if (type == 2) {
					// if(this.imgForm.imgCode== undefined || this.imgForm.imgCode == ''){
					//     this.$message.error('请输入图文验证码')
					//     return;
					// }
					console.log(this.imgForm.imgCode)
					params = {
						IsLogin: true,
						Mobile: this.imgForm.mobile,
						UUID: this.imgForm.imgUid,
						VerificationCode: this.imgForm.imgCode
					}
				} else if (type == 3) {
					if (this.imgFormIp.imgCode == undefined || this.imgFormIp.imgCode == '') {
						this.$message.error('请输入图文验证码')
						return;
					}
					params = {
						IsLogin: true,
						Mobile: this.imgFormIp.mobile,
						UUID: this.imgFormIp.imgUid,
						VerificationCode: this.imgFormIp.imgCode
					}
				}

				this.$api.sendMobileCode(params).then(res => {
					if (res.data.status) {
						this.$message.success("发送成功");
						if (type == '2') {
							this.imgForm.imgCode = ''
							const TIME_COUNT = 60;
							if (!this.timer) {
								this.count = TIME_COUNT;
								this.timer = setInterval(() => {
									if (this.count > 0 && this.count <= TIME_COUNT) {
										this.count--;
										this.timetext = this.count + 's后重新获取';
										this.disabled = true;
									} else {
										clearInterval(this.timer);
										this.timer = null;
										this.timetext = '获取验证码';
										this.disabled = false;
									}
								}, 1000)
							}
						}
						if (type == '3') {
							const TIME_COUNT = 60;
							if (!this.y_timer) {
								this.y_count = TIME_COUNT;
								this.y_timer = setInterval(() => {
									if (this.y_count > 0 && this.y_count <= TIME_COUNT) {
										this.y_count--;
										this.y_timetext = this.y_count + 's后重新获取';
										this.y_disabled = true;
									} else {
										clearInterval(this.y_timer);
										this.y_timer = null;
										this.y_timetext = '获取验证码';
										this.y_disabled = false;
									}
								}, 1000)
							}
						}
						if (type == 'wj') {
							const TIME_COUNT = 60;
							if (!this.wj_timer) {
								this.wj_count = TIME_COUNT;
								this.wj_timer = setInterval(() => {
									if (this.wj_count > 0 && this.wj_count <= TIME_COUNT) {
										this.wj_count--;
										this.wj_timetext = this.wj_count + 's后重新获取';
										this.wj_disabled = true;
									} else {
										clearInterval(this.wj_timer);
										this.wj_timer = null;
										this.wj_timetext = '获取验证码';
										this.wj_disabled = false;
									}
								}, 1000)
							}
						}
					} else {
						this.$message.error(res.data.message);
						this.imgForm.imgCode = ''
					}
				});
			},
			getVierificationCodeToLogin() {
				this.imgCodeLoading = true;
				this.$api.getVierificationCode({}).then(res => {
					this.imgForm.imgCodeUrl = "data:image/png;base64," + res.data.data.img;
					this.imgForm.imgUid = res.data.data.uuid;
					this.imgCodeLoading = false;
				});
			},
			getVierificationCodeIp() {
				this.imgCodeLoading = true;
				this.$api.getVierificationCode({}).then(res => {
					this.imgFormIp.imgCodeUrl = "data:image/png;base64," + res.data.data.img;
					this.imgFormIp.imgUid = res.data.data.uuid;
					this.imgCodeLoading = false;
				});
			},

			checkPW() {
				if (this.form.pwd.length < 8) {
					this.$message.error('请至少输入8位密码，包括数字和字母')
				} else {
					if (!this.form.pwd.match(/^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/)) {
						this.$message.error('请至少输入8位密码，包括数字和字母')
					}
				}

			},

			checkSPW() {
				if (this.form.surePwd != this.form.pwd) {
					this.$message.error('两次密码请保持一致！')
				}
			},
			showPW(type) {
				if (type == 1) {
					this.passWd = 2;
					this.type = 'text'
				} else {
					this.passWd = 1;
					this.type = 'password'
				}

			},
			showPW2(type) {
				if (type == 1) {
					this.passWd2 = 2;
					this.type2 = 'text'
				} else {
					this.passWd2 = 1;
					this.type2 = 'password'
				}

			},
			inputP() {
				this.msgText = this.checkStrong(this.form.pwd);
				console.log(this.msgText, '=====');
				if (this.msgText > 1 || this.msgText === 1) {
					document.getElementById('one').style.background = '#FBD582';
				} else {
					document.getElementById('one').style.background = '#eee';
				}
				if (this.msgText > 2 || this.msgText === 2) {
					document.getElementById('two').style.background = '#B7E3A5';
				} else {
					document.getElementById('two').style.background = '#eee';
				}
				if (this.msgText === 4) {
					document.getElementById('three').style.background = '#87D068';
				} else {
					document.getElementById('three').style.background = '#eee';
				}
			},
			checkStrong(sValue) {
				var modes = 0;
				// 正则表达式验证符合要求的
				if (sValue.length < 1) {
					return modes;
				}
				if (/\d/.test(sValue) && sValue.length >= 8) {
					modes++;
				} // 数字
				if (/[a-z]/.test(sValue) && sValue.length >= 8) {
					modes++;
				} // 小写
				if (/[A-Z]/.test(sValue) && sValue.length >= 8) {
					modes++;
				} // 大写
				if (/\W/.test(sValue) && sValue.length >= 8) {
					modes++;
				} // 特殊字符
				switch (modes) {
					case 1:
						return 1;
					case 2:
						return 2;
					case 3:
					case 4:
						return sValue.length < 4 ? 3 : 4;
				}
				return modes;
			},
		}
	}
</script>
<style scoped lang="scss">
	.dialogL {
		:deep .el-dialog {
			margin-top: 15vh !important;
			width: 50% !important;
		}

		:deep .el-dialog__body {
			padding: 30px 20px !important;
		}
	}

	.login-dialog {
		:deep .el-dialog__headerbtn {
			width: 40px;
			height: 40px;
			border: 1px solid #fff;
			border-radius: 50%;
			top: -40px !important;
			right: -35px !important;

			.el-dialog__close {
				color: #fff;
			}
		}

		:deep .el-dialog {
			margin-top: 15vh !important;
			background: transparent !important;
		}

		:deep .el-dialog__header {
			padding: 0 !important;
		}

		:deep .el-dialog__body {
			padding: 0 !important;
		}

		.dialog-main {
			background-color: var(--bgColor);
			border-radius: 16px;
		}

		.log_header {
			height: 160px;

			img {
				width: 100%;
				height: 100%;
				border-radius: 16px 16px 0 0;
			}
		}

		.conmain {
			height: 480px;
			padding-top: 78px;
			border-radius: 16px;
			background-color: #fff;
			display: flex;
			justify-content: space-between;
			box-sizing: border-box;

			.conmain-left {
				flex: 1;
				text-align: center;
				position: relative;

				h3 {
					font-size: 22px;
					font-weight: bold;
					line-height: 22px;
					color: #1A1A1A;
				}

				p {
					margin: 27px 0 24px 0;
					font-size: 16px;
					display: flex;
					align-items: center;
					justify-content: center;
					line-height: 1;

					img {
						display: block;
						width: 16px;
						height: 16px;
						margin: 0 6px;
					}

					span {
						font-weight: normal;

						color: #2AA32A;
					}
				}

				#login_container {
					width: 202px;
					height: 202px;
					box-sizing: border-box;
					margin: 0 auto;
					display: flex;
					// align-items: center;
					justify-content: center;
				}

				.qrcode-refresh {
					display: inline-flex;
					align-items: center;
					margin-top: 12px;
					cursor: pointer;
					color: #666;
					font-size: 13px;
					user-select: none;

					i {
						margin-right: 4px;
						font-size: 15px;
					}
				}

				.qrcode-refresh:hover {
					color: var(--bgColor, #e60012);
				}
			}

			.conmain-left::after {
				position: absolute;
				content: "";
				right: 1px;
				top: 12%;
				width: 1px;
				height: 246px;
				background: #EBEBEB;
			}

			.conmain-right {
				flex: 1;
				text-align: center;

				.login_title {
					font-size: 20px;
					color: #1A1A1A;
					font-weight: bold;

					ul {
						li {
							display: inline-block;
							cursor: pointer;
						}
					}
				}

				.login_input {
					width: 368px;
					height: 44px;
					line-height: 44px;
					margin: 0 auto;
					overflow: hidden;
					border-radius: 8px;
					background: #F7F8FC;
					color: #000000;
					font-size: 14px;
					display: flex;
					margin-top: 16px;
					align-items: center;

					img {
						width: 20px;
						height: 20px;
						margin-left: 24px;
					}

					input {
						width: 310px;
						border: none;
						background: none;
						line-height: normal;
						font-size: 14px;
						padding: 11px;
					}

					.sendCode {
						height: 40px;
					}
				}

				.login_btn {
					width: 368px;
					height: 44px;
					line-height: 44px;
					border-radius: 8px;
					background: var(--bgColor, #e60012);
					display: block;
					clear: both;
					margin: 28px auto 54px auto;
					text-align: center;
					font-size: 16px;
					color: var(--fontColor, #fff);
					letter-spacing: 0.12em;
					/* margin-top: 30px; */
					border: none;
					cursor: pointer;
				}

				#msgtips {
					width: 300px;
					font-size: 13px;
					margin: 0 auto;
					color: #999;

					.text {
						color: #F00;
					}

					.num {
						font-weight: bold;
						font-size: 15px;
					}

					.btn_f {
						cursor: pointer;
						color: #F00;
					}
				}

				.login-span {
					color: #666666;
					font-size: 14px;

					img {
						width: 14px;
						height: 14px;
						margin-right: 8px;
						vertical-align: middle;
					}

					span,
					a {
						padding: 0 16px;
						position: relative;
						cursor: pointer;
					}

					span::after {
						position: absolute;
						content: "";
						right: 1px;
						top: 20%;
						width: 1px;
						height: 10px;
						background: #DFDFDF;
					}
				}
			}
		}
	}

	.protocolContent .btn {
		background-color: var(--bgColor, #e60012);
		border: 0;
		font-size: 13px;
		border-radius: 2px 2px 2px 2px;
		color: #FFF;
		display: inline-block;
		height: 30px;
		line-height: 30px;
		min-width: 48px;
		padding: 0 25px;
		text-align: center;
		font-family: "Microsoft Yahei";
	}

	.protocolContent .part {
		padding: 15px 0 0 0;
	}


	.step_wrap {
		display: flex;
		align-items: center;

		.item {
			margin: 0 2px;
			flex: 1;
			color: var(--bgColor, red);
			text-align: center;
			position: relative;
			height: 30px;
			line-height: 30px;

			span {
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
			}
		}

		.item::after {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			width: 100%;
			height: 100%;
			background-color: var(--bgColor, red);
			opacity: 0.2;
		}

		.item.active {
			color: #fff;
			background-color: var(--bgColor, red);
		}
	}

	.form_box dl {
		clear: both;
		padding: 8px 0;
		font-size: 12px;
	}

	.form_box dl dt {
		display: block;
		float: left;
		width: 150px;
		text-align: right;
		font-weight: normal;
		line-height: inherit;
	}

	.form_box dl dd {
		margin-left: 150px;
		padding-left: 10px;
		font-weight: normal;
		line-height: inherit;
		display: flex;
	}

	input.txt {
		width: 255px;
	}

	input.small {
		width: 130px;
	}

	.input {
		box-sizing: content-box;
		display: inline;
		margin-right: 5px;
		padding: 5px;
		height: 18px;
		line-height: 18px;
		vertical-align: middle;
		background: #fff;
		color: #999;
		border: 1px solid #CACACA;
		border-radius: 4px 4px 4px 4px;
		font-family: 'Microsoft YaHei';
		vertical-align: baseline;
	}

	.small,
	small {
		font-size: 85%;
	}

	.form_box dl dd .btn_submit {
		padding: 10px 30px;
		border: 1px solid #429342;
		background: #52A152;
		color: #fff;
		font-size: 14px;
		line-height: 1em;
		cursor: pointer;
		font-family: 'Microsoft YaHei';
	}

	.sumbtn {
		border: 1px solid var(--bgColor, #e60012);
		background-color: var(--bgColor, #e60012);
		color: #fff;
	}

	input[type=checkbox] {
		cursor: pointer;
		position: relative;
		width: 15px;
		height: 15px;
		font-size: 12px;
		margin-right: 2px;
		vertical-align: -2px;
	}

	input[type=checkbox]:checked:after {
		content: "✓";
		color: #fff;
		font-size: 12px;
		background-color: #e60012;
		line-height: 15px;
	}

	input[type=checkbox]:after {
		position: absolute;
		top: 0;
		width: 15px;
		height: 15px;
		display: inline-block;
		visibility: visible;
		padding-left: 0;
		text-align: center;
		border-radius: 3px;
	}

	#chkRemember input[type=checkbox]:checked::after {
		background: var(--bgColor, #e60012);
	}

	#chkRemember a {
		cursor: pointer;
	}

	#chkRemember a:hover {
		color: var(--bgColor);
	}

	// 异地登录

	.ipmatch .logo {
		width: 200px;
		display: block;
		margin: 0 auto;
	}

	.ipmatch .tips {
		margin: 30px 0;
		text-align: center;

		.iconfont {
			color: #ffb402;
			margin-right: 5px;
		}
	}

	.ipmatch .login_input {
		width: 300px;
		height: 42px;
		// border: 1px solid #bdbdbd;
		line-height: 42px;
		margin: 0 auto;
		overflow: hidden;
		font-size: 16px;
		color: #666;
		margin-top: 12px;
		background-color: #f1f1f1;
		border-radius: 5px;
	}

	.ipmatch .login_input input {
		width: 280px;
		border: none;
		background: none;
		line-height: normal;
		font-size: 14px;
		padding: 10px;
	}

	.ipmatch .login_input input.small {
		width: 153px;
	}

	// .ipmatch .login_input input.sendCode {
	// 	width: 119px;
	// 	color: #fff;
	// 	background: var(--bgColor, #e60012);
	// 	height: 43px;
	// }

	.ipmatchbtn {
		padding: 12px 50px;
		font-size: 16px;
	}

	.btn_code.disabled {
		opacity: 0.5;
	}

	.input_item {
		width: 286px;
		position: relative;

		i {
			color: #999;
			position: absolute;
			top: 1px;
			right: 22px;
			font-size: 20px;
			cursor: pointer;
		}

		.off {}

		.on {}
	}

	.pwStrong {
		width: 268px;
		margin-top: 5px;
		line-height: 15px;

		.input_span {
			display: inline-block;

			span {
				display: inline-block;
				width: 79px;
				height: 10px;
				margin-right: 5px;
				background-color: #eee;

				&:first-child {
					border-right: 0;
					border-radius: 5px 0 0 5px;
				}

				&:last-child {
					border-left: 0;
					border-radius: 0 5px 5px 0;
				}
			}
		}

		.pw_font {
			display: inline-block;
		}
	}
</style>